import React from "react";
import { ProfileImages } from "../../../../common/styled/project";

const CurrentRooms = ({ projectRoomList, renderProfileImages }) => {
  return (
    <>
      <h4>현재 채팅룸 ({projectRoomList.length}개)</h4>
      <ul className="rooms">
        {projectRoomList.map((item, index) => (
          <li key={index}>
            {item.orgInfos && <ProfileImages>{renderProfileImages(item.orgInfos)}</ProfileImages>}
            <span className="tit">
              {item.orgInfos?.map((orgInfo, idx) => (
                <React.Fragment key={idx}>
                  {orgInfo?.orgNm}
                  {idx !== item.orgInfos.length - 1 && ", "}
                </React.Fragment>
              ))}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default CurrentRooms;
